import React from 'react';
import StatsTable from '../charts/StatsTable';
import type { TodayStatsResponse } from '../statsTypes';

interface TodayTabProps {
  data: TodayStatsResponse | null;
}

const COLUMNS = [
  { key: 'region_name', label: 'Region' },
  { key: 'actioning', label: 'Actioning' },
  { key: 'monitoring', label: 'Monitoring' },
  { key: 'out', label: 'Out' },
  { key: 'total', label: 'Total' },
];

const TodayTab: React.FC<TodayTabProps> = ({ data }) => {
  if (!data) return <p>No data available</p>;

  const rows = [
    ...data.regions,
    { ...data.totals, region_name: 'NT Total' },
  ];

  return (
    <div className="stats-today-tab">
      <h3>Current Fire Status</h3>
      <StatsTable columns={COLUMNS} rows={rows} title="Active Fires by Region" />
    </div>
  );
};

export default TodayTab;
